var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isValid)?_c('span',[_vm._v("—")]):(_vm.fancyDate)?_c('span',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formattedDate))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedTime))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.timezoneOffset))])]):_c('span',[_vm._v(_vm._s(_vm.formattedTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }